import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import iconChevron from "@dhl-official/icons/chevron-back.svg";
import iconChevronForward from "@dhl-official/icons/chevron-forward.svg";
import iconDoubleChevron from "@dhl-official/icons/double-chevron-back.svg";
// eslint-disable-next-line import/no-cycle
import { Icon } from "root/libs/ui-components/src";
import { TYPES } from "./constants";
import { NavIconButton } from "./NavIconButton";

// #region Component Styles
const StyledIcon = styled(Icon).attrs({
  "aria-hidden": true,
  role: "presentation",
})`
  display: block;
  width: 20px;
  height: 20px;
`;
// #endregion

export const Nav = ({
  id,
  type,
  onChangeMonth,
  onChangeYear,
  show,
  disableMonth,
  disableYear,
  ariaLabelForMonth,
  ariaLabelForYear,
}) => {
  const monthId = `${id}-${type}-month`;
  const yearId = `${id}-${type}-year`;

  return show ? (
    <React.Fragment>
      {type === TYPES.NAV.PREV ? (
        <React.Fragment>
          <NavIconButton
            onClick={onChangeYear}
            iconComponent={<StyledIcon icon={iconDoubleChevron} />}
            ariaLabel={ariaLabelForYear}
            id={yearId}
            disabled={disableYear}
          />
          <NavIconButton
            onClick={onChangeMonth}
            iconComponent={<StyledIcon icon={iconChevron} />}
            ariaLabel={ariaLabelForMonth}
            id={monthId}
            disabled={disableMonth}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <NavIconButton
            onClick={onChangeMonth}
            iconComponent={<StyledIcon icon={iconChevronForward} />}
            ariaLabel={ariaLabelForMonth}
            id={monthId}
            disabled={disableMonth}
          />
          <NavIconButton
            onClick={onChangeYear}
            iconComponent={<StyledIcon icon={iconDoubleChevron} />}
            ariaLabel={ariaLabelForYear}
            rotate="180deg"
            id={yearId}
            disabled={disableYear}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  ) : (
    ""
  );
};

Nav.propTypes = {
  id: PropTypes.string,
  /** Which direction the chevron should show */
  type: PropTypes.oneOf(Object.values(TYPES.NAV)),
  /** Callback or click handler for this nav item */
  onChangeMonth: PropTypes.func,
  onChangeYear: PropTypes.func,
  /** Should we show or hide this icon button? */
  show: PropTypes.bool,
  disableMonth: PropTypes.bool,
  disableYear: PropTypes.bool,
  ariaLabelForMonth: PropTypes.string,
  ariaLabelForYear: PropTypes.string,
};
